<template>
    <div>

    
        <!-- Main Tabs -->
        <b-card no-body>
            <b-tabs card>

               <b-tab title="Container Orders"
                v-if="['admin', 'officemanager', 'warehouseuser',
                    'warehousemanager'].includes(packet.userDetails.userrole)" >

                    <ContainerOrders />
                </b-tab>

                <b-tab title="Stock Vendor Orders">
                    <StockOrder/>
                </b-tab>

                <b-tab title="Customer Vendor Orders">
                    <CustomerBackOrders/>
                </b-tab>

                 <b-tab title="Store Transfer Orders">
                    <StoreReceivingTransferOrders/>
                </b-tab>
                <b-tab title="Customer Orders">
                    <StoreReceivingCustomerOrders/>
                </b-tab>

            

                


            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import moment from 'moment'
import mappings from '@/utilities/mappings'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import TransferOrderModal from '@/components/TransferOrders/TransferOrderModal';
import ContainerOrders from "@/components/VendorOrders/ListContainerOrders"
import StockOrder from "@/components/VendorOrders/ListStockOrders"
import StockOrderItems from "@/components/VendorOrders/StockOrderItems"
import CustomerBackOrders from "@/components/VendorOrders/ListCustomerBackOrders"
import StoreReceivingTransferOrders from "@/components/IncomingOutGoing/StoreReceivingTransferOrders"
import MeccaReceiving from "@/components/IncomingOutGoing/MeccaReceiving"
import CustomerBackOrderItems from "@/components/VendorOrders/CustomerBackOrderItems"
import StoreReceivingCustomerOrders from "@/components/IncomingOutGoing/StoreReceivingCustomerOrders"
import { BIconFunnelFill, BIconEye, BIconEyeFill } from 'bootstrap-vue'

export default {
    name: "CombinedOrders",
    props: [],
    components: { flatPickr, Loading, DatePicker, VueSimpleSuggest,StoreReceivingCustomerOrders,MeccaReceiving, StoreReceivingTransferOrders, CustomerBackOrders, StockOrder,ContainerOrders,TransferOrderModal, StockOrderItems, CustomerBackOrderItems, BIconFunnelFill, BIconEye, BIconEyeFill },
    data: function() {
        return {
            // Common data
            packet: {},
            isMobile: false,
            
            // Transfer Orders data
            show: true,
            first_load: null,
            transferItems: [], // Default items (filtered to exclude RECEIVED and COMPLETED)
            allTransferItems: [], // All items including RECEIVED and COMPLETED
            transfer_items_being_loaded: null,
            transfer_order_id: null,
            products: [],
            locations: [],
            trucks: [],
            selectedLocation: null,
            selected_delivery_date: null,
            selected_schedule_date: null,
            selected_status: null,
            selectedStatus: null,
            filteredTransferItems: [],
            filterLocationOptions: [
                { value: null, text: 'All Locations' },
            ],
            filterStatusOptions: [
                { value: null, text: 'All' },
            ],
            selectedSellingLocation: null,
            filterSellingLocationOptions: [
                { value: null, text: 'All Selling Locations' },
            ],
            meccaWholesaleValue: 0,
            locationPrefixes: {
                'ALLENTOWN STORE': 'AT',
                'MECCA SHIPPING': 'MS',
                '101 WH': 'WH-VEN',
                'FOLCROFT': 'WH-FOL',
                '9TH ST ': 'WH-9',
                'VENANGO STORE': '101',
                'READING STORE': 'RD',
                'LANCASTER AVE STORE': '56-ST',
                'EWING STORE': 'EW',
                'DELMAR STORE': 'FLC',
                'LANSDOWNE STORE': 'BLT',
                'UPPER DARBY STORE': 'UD',
                'HUNTING PARK STORE': 'UD',
            },
            transferFiltersVisible: false,
            showAllItems: false, // Toggle to show all transfer items including RECEIVED and COMPLETED
            
            // Stock Orders data
            stockItems: [],
            stock_items_being_loaded: null,
            stockStatuses: [
                {value: 1, text: "NEW"},
                {value: 2, text: "ORDERED"},
                {value: 3, text: "SCHEDULED"},
                {value: 4, text: "IN-TRANSIT"},
                {value: 5, text: "PARTIAL"},
                {value: 6, text: "RECEIVED"},
                {value: 7, text: "COMPLETED"},
                {value: 8, text: "ARCHIVED"},
            ],
            no_items_status: [],
            emailForm: {
                email: '',
                subject: '',
                message: '',
                poNumber: '',
                vendorName: '',
                itemsCount: 0,
                stockOrderId: null
            },
            pms: [
                { value: "CHECK", text: "CHECK" },
                { value: "WIRE", text: "WIRE" },
                { value: "CASH", text: "CASH" },
            ],
            stock_order_id: null,
            stock_order_vendor_id: null,
            create_new: false,
            
            // Stock Order Filters
            stockStatus: null,
            stockVendor: null,
            stockDateRange: [],
            stockShipToFilter: null,
            stockReceivingLocFilter: null,
            
            // Location options for stock orders
            receiving_locations: [],
            filter_locations: [],
            filter_receiving_locations: [],
            
            isStockDetailsExpanded: false,
            vendorOrderCounters: {},
            userDetails: JSON.parse(localStorage.userDetails),
            stockFiltersVisible: false,
            
            // Transfer Order Statuses
            transferStatuses: [
                {value: 1, text: "ORDERED"},
                {value: 2, text: "SCHEDULED"},
                {value: 4, text: "PARTIAL"},
                {value: 3, text: "RECEIVED"},
                {value: 5, text: "COMPLETED"},
                {value: 6, text: "ARCHIVED"},
                {value: 7, text: "UNAPPROVED"},

            ],
            
            // Customer Backorders data
            backorderItems: [],
            backorder_items_being_loaded: null,
            backorderStatuses: [
                {value: "open", text: "OPEN"},
                {value: 1, text: "NEW"},
                {value: 2, text: "ORDERED"},
                {value: 3, text: "SCHEDULED"},
                {value: 4, text: "IN-TRANSIT"},
                {value: 5, text: "PARTIAL"},
                {value: 6, text: "RECEIVED"},
                {value: 7, text: "COMPLETED"},
                {value: 8, text: "ARCHIVED"},
            ],
            customer_backorder_po_id: null,
            customer_backorder_po_vendor_id: null,
            
            // Customer Backorder Filters
            backorderStatus: "open",
            backorderVendor: null,
            backorderDateRange: [],
            backorderShipToFilter: null,
            backorderReceivingLocFilter: null,
            backorderItemSearch: '',
            
            backorderFiltersVisible: false,
            isBackorderDetailsExpanded: false,
            
            // Customer Backorder locations
            bill_to_location: [],
            Ship_to_location: [],
            receiving_dropdown_locations: [],
        }
    },

    
  
    
   
    
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    
    created() {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
        console.log(this.packet.userDetails);
        
        // Initialize Transfer Orders
        if (this.packet.userDetails.userrole !== 'admin') {
            this.selling_locations = this.packet.locations.filter(function(d) {
                return [40, 41, 42].includes(d.value);
            });
        } else {
            this.selling_locations = this.packet.locations.filter(function(d) {
                return d.text != 'All';
            });
        }
        
        this.filterStatusOptions = [
            { value: null, text: 'All' },
            ...this.transferStatuses
        ];
        
        let allLocations = this.packet.locations.filter(function(d) { return d.text != 'All' });
        
        this.filterLocationOptions = [
            { value: null, text: 'All Locations' },
            ...allLocations.map(loc => ({
                value: loc.value,
                text: loc.text
            }))
        ];
        
        this.filterSellingLocationOptions = [
            { value: null, text: 'All Shipping Locations' },
            ...this.selling_locations.map(loc => ({
                value: loc.value,
                text: loc.text
            }))
        ];
        
        if (!['admin', 'officemanager', 'housetruck', 'deliverytruck'].includes(this.packet.userDetails.userrole)) {
            const userLocationId = this.packet.userDetails.properties.location_id;
            this.locations = allLocations.filter(function(d) {
                return d.value == userLocationId;
            });
        } else {
            if (['admin'].includes(this.packet.userDetails.userrole)) {
                this.locations = allLocations.filter(item => ![46, 47].includes(item.value));
            } else {
                this.locations = allLocations.filter(item => ![46].includes(item.value));
            }
        }
        
        this.trucks = this.packet.housetrucks.filter(function(d) { return d.text != "" });
        
        // Initialize Stock Orders
        this.packet.vendors.splice(0, 0, { value: null, text: "ALL" });
        this.setupLocations();
        this.fetch_orders();
        this.fetch_customer_backorders();
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Receiving/ReceivingOrder.vue